module.exports = __webpack_public_path__ + "static/media/Sonic.d55702b0.png";